// extracted by mini-css-extract-plugin
module.exports = {"adSlot":"AdPosition-module--adSlot--2Jjbh","overline":"AdPosition-module--overline--1jE7i"};